import React from 'react';
import { useNavigate } from 'react-router-dom';

const ItemView = () => {
  const navigate = useNavigate();

  // RCN category items with their corresponding view routes
  const items = [
    { 
      id: 1, 
      name: 'Calibrated RCN', 
      path: '/admin/warehouse/view',
      description: 'View calibrated raw cashew nuts inventory',
      icon: '🥜'
    },
    { 
      id: 2, 
      name: 'Organic RCN', 
      path: '/admin/warehouse/view/organic',
      description: 'View certified organic raw cashew nuts',
      icon: '🌱'
    },
    { 
      id: 3, 
      name: 'Fair Trade RCN', 
      path: '/admin/warehouse/view/fairtrade',
      description: 'View fair trade certified raw cashew nuts',
      icon: '🤝'
    }
  ];

  return (
    <div className="item-view-container">
      <h2>View RCN Inventory</h2>
      <div className="menu-cards">
        {items.map((item) => (
          <div 
            key={item.id}
            className="menu-card"
            onClick={() => navigate(item.path)}
          >
            <div className="card-icon">{item.icon}</div>
            <h3>{item.name}</h3>
            <p>{item.description}</p>
          </div>
        ))}
      </div>

      <style jsx>{`
        .item-view-container {
          padding: 20px;
          max-width: 1200px;
          margin: 0 auto;
        }

        .menu-cards {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
          gap: 30px;
          margin-top: 20px;
        }

        .menu-card {
          background: white;
          border-radius: 12px;
          padding: 25px;
          cursor: pointer;
          transition: all 0.3s ease;
          border: 1px solid #eee;
          text-align: center;
          min-height: 200px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
        }

        .menu-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
          border-color: #1A237E;
          background-color: #f8f9ff;
        }

        .card-icon {
          font-size: 3rem;
          margin-bottom: 15px;
        }

        h2 {
          color: #1A237E;
          font-size: 28px;
          margin-bottom: 30px;
          text-align: center;
        }

        h3 {
          color: #1A237E;
          font-size: 20px;
          margin-bottom: 12px;
          font-weight: 600;
        }

        p {
          color: #666;
          font-size: 15px;
          line-height: 1.5;
        }

        @media (max-width: 768px) {
          .menu-cards {
            grid-template-columns: 1fr;
          }
          
          .menu-card {
            min-height: 180px;
          }
          
          h2 {
            font-size: 24px;
          }
        }
      `}</style>
    </div>
  );
};

export default ItemView; 